import { render, staticRenderFns } from "./SpcRuleModal.vue?vue&type=template&id=4eb64e19&slot=items&"
import script from "./SpcRuleModal.js?vue&type=script&lang=js&"
export * from "./SpcRuleModal.js?vue&type=script&lang=js&"
import style0 from "./SpcRuleModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports